// ТЕКСТ ПОЛЬЗОВАТЕЛЬСКОГО СОГЛАШЕНИЯ (ПУБЛИЧНОЙ ОФЕРТЫ) — ОДИН НА СТРАНИЦУ /oferta И НА СЛОЙ
// И ПАНЕЛЬ СПРАВКИ КАБИНЕТА (ТЗ ANIM-FIX О6, решение владельца 04.10.2026, по образцу
// privacy-text.tsx). Слова документа живут здесь; страница (app/[locale]/oferta/page.tsx) и
// справка кабинета (cabinet/help-layer.tsx) рисуют их в одном каркасе LegalShell.
import { LEGAL_EMAIL } from './legal-shell';

/** Название и редакция документа — шапка страницы и слоя. */
export function termsHead(locale: string): { title: string; updated: string } {
  return locale === 'en'
    ? { title: 'Terms of Service', updated: 'Last updated: July 29, 2026' }
    : { title: 'Публичная оферта', updated: 'Редакция от 29 июля 2026 года' };
}

/** Тело документа на языке страницы. */
export function TermsText({ locale }: { locale: string }) {
  return locale === 'en' ? <En /> : <Ru />;
}

const MAIL = <a href={`mailto:${LEGAL_EMAIL}`}>{LEGAL_EMAIL}</a>;

function Ru() {
  return (
    <>
      <h2>1. Введение</h2>
      <p>
        Scriptera («Сервис», «мы») — сервис, который собирает и запускает чат-ботов и
        автоматизации («сценарии») в Telegram, Instagram, на сайтах и в других каналах: вы
        описываете задачу, Сервис собирает сценарий, запускает его и следит, чтобы он
        работал. Настоящий документ — публичная оферта: регистрация учётной записи или
        оплата означает полное принятие этих условий. Мы можем обновлять условия;
        продолжение использования Сервиса после публикации новой редакции означает согласие
        с ней.
      </p>

      <h2>2. Использование Сервиса</h2>
      <h3>2.1. Возраст</h3>
      <p>Использовать Сервис могут лица, достигшие 18 лет.</p>
      <h3>2.2. Учётная запись</h3>
      <p>
        Вы указываете достоверные данные, храните пароль в тайне и не передаёте доступ
        третьим лицам. Все действия из вашей учётной записи считаются вашими; о
        подозрении на взлом сообщите нам незамедлительно.
      </p>
      <h3>2.3. Лицензия</h3>
      <p>
        Мы предоставляем вам ограниченное, неисключительное право пользоваться Сервисом для
        себя и своего бизнеса. Перепродавать Сервис или его части запрещено.
      </p>

      <h2>3. Ваш контент</h2>
      <p>
        Всё, что вы загружаете в сценарии (тексты, файлы, товары, базы знаний), остаётся
        вашим. Вы даёте нам неисключительную лицензию использовать этот контент
        исключительно для работы Сервиса. Мы не используем ваш контент для обучения
        ИИ-моделей. Через сценарии проходят сообщения ваших подписчиков — вы отвечаете за
        законность их сбора и обработку (подробнее — в{' '}
        <a href="/ru/privacy">Политике конфиденциальности</a>).
      </p>

      <h2>4. Запрещённые действия</h2>
      <ul>
        <li>
          рассылать спам и сообщения без согласия получателей, вести мошеннические схемы;
        </li>
        <li>
          загружать и распространять незаконный, оскорбительный или нарушающий чужие права
          контент;
        </li>
        <li>
          нарушать правила подключаемых платформ (Telegram, Meta и других) — их санкции к
          вашим аккаунтам вне нашего контроля;
        </li>
        <li>
          вмешиваться в работу Сервиса: несанкционированный доступ, обратная разработка,
          автоматизированный сбор данных, вредоносный код;
        </li>
        <li>давать доступ к одной учётной записи нескольким лицам вне штатных ролей Сервиса.</li>
      </ul>
      <p>При нарушении мы вправе приостановить или прекратить доступ к Сервису.</p>

      <h2>5. Тарифы и оплата</h2>
      <ul>
        <li>
          Сервис предоставляется по подписке; действующие тарифы и цены — на scriptera.ai. Цены
          указываются в российских рублях, евро или долларах США в зависимости от страны. Мы можем
          менять тарифы, предупредив не менее чем за 30 дней.
        </li>
        {/* Якорь `autorenew` — сюда ведёт ссылка строки согласия на экране расчёта (PAY-FLOW-TZ §8 п.10.9). */}
        <li id="autorenew">
          Автопродление. При оплате подписки вы можете включить автопродление. Включая его, вы
          соглашаетесь с регулярными списаниями с сохранённой карты: в конце каждого оплаченного
          периода (месяц или год) списывается стоимость следующего периода за оплаченное число
          аккаунтов. Сумма и дата следующего списания показываются перед оплатой и на странице
          «Тариф». Списания проводит платёжный сервис: Робокасса (рубли) или Stripe (евро и
          доллары США).
        </li>
        <li>
          Перед списанием мы присылаем напоминание: за 3 дня для месячной подписки и за 7 дней для
          годовой.
        </li>
        <li>
          Выключить автопродление можно в любой момент на странице «Тариф» — доступ сохранится
          до конца оплаченного периода, сохранённая карта останется. Удалить сохранённую карту можно
          там же в любой момент; если автопродление было включено, оно выключится.
        </li>
        <li>
          Полные данные карт мы не получаем и не храним — их хранит платёжный сервис; нам видны
          только последние четыре цифры номера.
        </li>
        <li>ИИ-операции оплачиваются с отдельного баланса, который пополняется на сайте.</li>
        <li>
          Возвраты — по заявлению на {MAIL}; рассматриваем до 10 рабочих дней в
          соответствии с законодательством РФ.
        </li>
        <li>
          При длительной неоплате доступ ограничивается, а учётная запись может быть
          удалена — с предупреждением не менее чем за 30 дней.
        </li>
      </ul>

      <h2>6. Интеллектуальная собственность</h2>
      <p>
        Сервис, его дизайн, код и материалы принадлежат нам и нашим лицензиарам; вы
        получаете только право пользования. Если считаете, что в Сервисе нарушены ваши
        авторские права, — напишите на {MAIL} с темой «Авторские права».
      </p>

      <h2>7. Обновления Сервиса</h2>
      <p>
        Мы развиваем Сервис: функции могут добавляться, меняться и отключаться, возможны
        плановые и внеплановые технические перерывы. Существенные изменения анонсируются в
        Сервисе.
      </p>

      <h2>8. ИИ-функции</h2>
      <h3>8.1. Что это</h3>
      <p>
        Сценарии могут отвечать вашей аудитории с помощью моделей искусственного
        интеллекта: обрабатывать тексты, изображения и документы от вашего имени.
      </p>
      <h3>8.2. Точность</h3>
      <p>
        Ответы ИИ могут быть неточными или неуместными. Вы настраиваете инструкции до
        запуска, следите за ответами своих сценариев и отвечаете за них перед своей
        аудиторией.
      </p>
      <h3>8.3. Допустимое использование</h3>
      <p>
        Запрещено использовать ИИ для незаконного контента, введения в заблуждение, обхода
        ограничений провайдеров моделей и сбора чувствительных данных без согласия. Мы
        можем приостановить ИИ-функции сценария, нарушающего эти правила.
      </p>
      <h3>8.4. Провайдеры</h3>
      <p>
        ИИ-запросы обрабатывают Anthropic, OpenAI, Google и другие провайдеры по своим
        коммерческим условиям API; ваши данные не используются для обучения их моделей.
      </p>

      <h2>9. Срок действия и прекращение</h2>
      <ul>
        <li>
          Вы можете прекратить использование и запросить удаление учётной записи в любой
          момент (порядок — на странице <a href="/ru/data-deletion">«Удаление данных»</a>).
        </li>
        <li>
          Мы можем прекратить доступ при нарушении условий, а при прекращении работы
          Сервиса — предупредим минимум за 30 дней и вернём неиспользованную часть
          предоплаты.
        </li>
        <li>
          В течение 30 дней после удаления учётной записи можно запросить копию своего
          контента в машиночитаемом виде.
        </li>
      </ul>

      <h2>10. Гарантии и ответственность</h2>
      <p>
        Сервис предоставляется «как есть». Мы не отвечаем за перерывы и ограничения,
        вызванные внешними платформами и провайдерами, за контент третьих лиц и за
        косвенные убытки. Совокупная ответственность ограничена суммой, уплаченной за
        последний оплаченный период подписки.
      </p>

      <h2>11. Применимое право и споры</h2>
      <p>
        К отношениям сторон применяется право РФ. Споры решаются в претензионном порядке
        (ответ — до 10 рабочих дней), затем — в суде по месту нахождения исполнителя.
      </p>

      <h2>12. Прочее</h2>
      <p>
        Недействительность одного положения не отменяет остальных. Уведомления мы
        направляем по email или публикуем в Сервисе. Положения, по своей природе
        переживающие расторжение (ответственность, споры), сохраняют силу.
      </p>

      <h2>13. Контакты</h2>
      <p>Вопросы по условиям — на {MAIL}.</p>
    </>
  );
}

function En() {
  return (
    <>
      <h2>1. Introduction</h2>
      <p>
        Scriptera (the &quot;Service&quot;, &quot;we&quot;) builds and runs chatbots and
        automations (&quot;scenarios&quot;) in Telegram, Instagram, on websites and in
        other channels: you describe a task, the Service assembles the scenario, launches
        it and keeps it running. This document is a public offer: registering an account or
        making a payment constitutes full acceptance of these terms. We may update the
        terms; continued use of the Service after a new version is published means you
        accept it.
      </p>

      <h2>2. Using the Service</h2>
      <h3>2.1. Eligibility</h3>
      <p>You must be at least 18 years old to use the Service.</p>
      <h3>2.2. Your account</h3>
      <p>
        You provide accurate data, keep your password secret and do not share access. All
        actions from your account are deemed yours; notify us immediately of any suspected
        breach.
      </p>
      <h3>2.3. Licence</h3>
      <p>
        We grant you a limited, non-exclusive right to use the Service for yourself and
        your business. Reselling the Service or any part of it is prohibited.
      </p>

      <h2>3. Your content</h2>
      <p>
        Everything you upload to scenarios (texts, files, products, knowledge bases)
        remains yours. You grant us a non-exclusive licence to use it solely to operate the
        Service. We do not use your content to train AI models. Your subscribers&apos;
        messages pass through scenarios — you are responsible for collecting and processing
        them lawfully (see the <a href="/en/privacy">Privacy Policy</a>).
      </p>

      <h2>4. Prohibited activities</h2>
      <ul>
        <li>sending spam or messages without recipients&apos; consent, running fraudulent schemes;</li>
        <li>uploading or distributing illegal, abusive or infringing content;</li>
        <li>
          violating the rules of connected platforms (Telegram, Meta and others) — their
          sanctions against your accounts are outside our control;
        </li>
        <li>
          interfering with the Service: unauthorised access, reverse engineering, automated
          scraping, malicious code;
        </li>
        <li>sharing one account between multiple individuals outside the Service&apos;s built-in roles.</li>
      </ul>
      <p>In case of violation we may suspend or terminate access to the Service.</p>

      <h2>5. Plans and payment</h2>
      <ul>
        <li>
          The Service is subscription-based; current plans and prices are published at
          scriptera.ai. Prices are shown in Russian rubles, euros or US dollars depending on your
          country. We may change plans with at least 30 days&apos; notice.
        </li>
        <li id="autorenew">
          Auto-renewal. When you pay for a subscription, you can turn on auto-renewal. By turning it
          on, you agree to recurring charges to your saved card: at the end of each paid period (a
          month or a year), the price of the next period for the paid number of accounts is charged.
          The amount and date of the next charge are shown before you pay and on the
          &ldquo;Plan&rdquo; page. Charges are made by the payment provider: Robokassa
          (rubles) or Stripe (euros and US dollars).
        </li>
        <li>
          Before a charge we send you a reminder: 3 days before for a monthly subscription and 7
          days before for a yearly one.
        </li>
        <li>
          You can turn off auto-renewal at any time on the &ldquo;Plan&rdquo; page — access
          remains until the end of the paid period, and the saved card stays. You can remove the
          saved card there at any time; if auto-renewal was on, it turns off.
        </li>
        <li>
          We never receive or store full card details — the payment provider stores them; we only
          see the last four digits of the card number.
        </li>
        <li>AI operations are paid from a separate balance topped up on the website.</li>
        <li>
          Refunds — upon request to {MAIL}; handled within 10 business days in accordance
          with applicable law.
        </li>
        <li>
          Prolonged non-payment limits access, and the account may be deleted with at least
          30 days&apos; notice.
        </li>
      </ul>

      <h2>6. Intellectual property</h2>
      <p>
        The Service, its design, code and materials belong to us and our licensors; you
        receive only a right of use. If you believe the Service infringes your copyright,
        email {MAIL} with the subject &quot;Copyright&quot;.
      </p>

      <h2>7. Service updates</h2>
      <p>
        The Service evolves: features may be added, changed or removed, and planned or
        unplanned maintenance may occur. Material changes are announced in the Service.
      </p>

      <h2>8. AI features</h2>
      <h3>8.1. What it is</h3>
      <p>
        Scenarios may reply to your audience using artificial-intelligence models,
        processing texts, images and documents on your behalf.
      </p>
      <h3>8.2. Accuracy</h3>
      <p>
        AI responses may be inaccurate or inappropriate. You configure instructions before
        launch, monitor your scenarios&apos; responses and are responsible for them to your
        audience.
      </p>
      <h3>8.3. Acceptable use</h3>
      <p>
        Using AI for illegal content, deception, circumventing model providers&apos;
        restrictions or collecting sensitive data without consent is prohibited. We may
        suspend AI features of a scenario violating these rules.
      </p>
      <h3>8.4. Providers</h3>
      <p>
        AI requests are processed by Anthropic, OpenAI, Google and other providers under
        their commercial API terms; your data is not used to train their models.
      </p>

      <h2>9. Term and termination</h2>
      <ul>
        <li>
          You may stop using the Service and request account deletion at any time (see the{' '}
          <a href="/en/data-deletion">Data Deletion page</a>).
        </li>
        <li>
          We may terminate access for a breach of these terms; if the Service is
          discontinued, we give at least 30 days&apos; notice and refund the unused part of
          any prepayment.
        </li>
        <li>
          Within 30 days after account deletion you may request a machine-readable copy of
          your content.
        </li>
      </ul>

      <h2>10. Warranties and liability</h2>
      <p>
        The Service is provided &quot;as is&quot;. We are not liable for interruptions and
        restrictions caused by external platforms and providers, for third-party content,
        or for indirect damages. Aggregate liability is limited to the amount paid for the
        most recent subscription period.
      </p>

      <h2>11. Governing law and disputes</h2>
      <p>
        The relationship is governed by the law of the Russian Federation. Disputes are
        first addressed via a written claim (response within 10 business days), then in
        court at the operator&apos;s location.
      </p>

      <h2>12. Miscellaneous</h2>
      <p>
        If one provision is invalid, the rest remain in force. We send notices by email or
        publish them in the Service. Provisions that by their nature survive termination
        (liability, disputes) remain effective.
      </p>

      <h2>13. Contact</h2>
      <p>Questions about these terms — {MAIL}.</p>
    </>
  );
}
